var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"passenger-list"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$tc('passengers')))]),_vm._l((_vm.passengers),function(passenger,index){return _c('passenger-card',{key:index,attrs:{"passenger":passenger}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }